import { cn } from '@/lib/utils'
import { DOT, MONO, eur, eurS } from './format'
import type { RankItem } from '../types'

interface RankListProps {
  items: RankItem[]
  /** Show signed values + red barlines for negatives (refunds). */
  signed?: boolean
}

/** Generic ranked list with barlines — top revenue / products / refunds. */
export function RankList({ items, signed }: RankListProps) {
  const max = Math.max(1, ...items.map((i) => Math.abs(i.eur)))
  return (
    <div className="space-y-2.5">
      {items.map((it, i) => {
        const neg = signed && it.eur < 0
        return (
          <div key={i} className="flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                {it.dot ? (
                  <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: DOT[it.dot] || '#9A938A' }} />
                ) : null}
                <span className="truncate text-sm text-stone-700 dark:text-stone-200">{it.name}</span>
                {it.tag ? (
                  <span className="shrink-0 rounded bg-stone-100 px-1.5 py-px text-[10px] text-stone-500 dark:bg-stone-800 dark:text-stone-400">
                    {it.tag}
                  </span>
                ) : null}
              </div>
              {(it.sub || it.prod) && <p className="truncate text-xs text-stone-400">{it.sub || it.prod}</p>}
              <div className="mt-1 h-1 w-full overflow-hidden rounded bg-stone-100 dark:bg-stone-800">
                <div
                  className="h-full rounded"
                  style={{ width: `${(Math.abs(it.eur) / max) * 100}%`, backgroundColor: neg ? '#C8453E' : '#AE9056' }}
                />
              </div>
            </div>
            <span
              className={cn('shrink-0 text-sm font-medium', MONO, neg ? 'text-red-600 dark:text-red-400' : 'text-stone-800 dark:text-stone-100')}
            >
              {signed ? eurS(it.eur) : eur(it.eur)}
            </span>
          </div>
        )
      })}
    </div>
  )
}
